import { render, staticRenderFns } from "./SelectQuestion.vue?vue&type=template&id=068c5d3e&scoped=true"
import script from "./SelectQuestion.vue?vue&type=script&lang=js"
export * from "./SelectQuestion.vue?vue&type=script&lang=js"
import style0 from "./SelectQuestion.vue?vue&type=style&index=0&id=068c5d3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068c5d3e",
  null
  
)

export default component.exports